import React, { useMemo } from 'react';
import { Avatar, Card, Col, Row, Empty, Badge, Space, Typography } from 'antd';
import SnapshotTable from './SnapshotTable';
import { toDate } from '../../../utils/datetime';
import _ from 'lodash';

const SnapshotCollection = ({ historyData }) => {
  const uniqueSnapshots = useMemo(() => {
    if (!historyData) return [];

    const groupedSnapshots = _.groupBy(historyData, (item) =>
      JSON.stringify(item.snapshot)
    );

    return Object.entries(groupedSnapshots).map(([key, items]) => ({
      snapshot: JSON.parse(key),
      count: items.length,
      timestamps: items.map((item) => item.timestamp),
    }));
  }, [historyData]);

  if (!historyData) return <Empty />;

  return (
    <Row gutter={16}>
      {uniqueSnapshots.map((item, index) => (
        <Col span={8} key={index}>
            <Card
              bordered={false}
            >
              <Badge count={item.count > 1 ? item.count : 0}>
                <Row align={'middle'} justify={'start'} className={'px-4'}>
                    <Typography.Title  level={3}>
                      {toDate(item.timestamps[0])}
                    </Typography.Title>
                </Row>
              </Badge>
              <SnapshotTable snapshot={item.snapshot} />
            </Card>
        </Col>
      ))}
    </Row>
  );
};

export default SnapshotCollection;